/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetListItemResponseDto } from './AssetListItemResponseDto';
import {
    AssetListItemResponseDtoFromJSON,
    AssetListItemResponseDtoFromJSONTyped,
    AssetListItemResponseDtoToJSON,
    AssetListItemResponseDtoToJSONTyped,
} from './AssetListItemResponseDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListAssetsResponseDto
 */
export interface ListAssetsResponseDto {
    /**
     * 
     * @type {Array<AssetListItemResponseDto>}
     * @memberof ListAssetsResponseDto
     */
    data: Array<AssetListItemResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListAssetsResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListAssetsResponseDto interface.
 */
export function instanceOfListAssetsResponseDto(value: object): value is ListAssetsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListAssetsResponseDtoFromJSON(json: any): ListAssetsResponseDto {
    return ListAssetsResponseDtoFromJSONTyped(json, false);
}

export function ListAssetsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAssetsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(AssetListItemResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListAssetsResponseDtoToJSON(json: any): ListAssetsResponseDto {
    return ListAssetsResponseDtoToJSONTyped(json, false);
}

export function ListAssetsResponseDtoToJSONTyped(value?: ListAssetsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(AssetListItemResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

